import {onlyIfForm, useSelector} from '../../../../store.js'
import ConfirmModal from '../../../../common/components/Modal/ConfirmModal.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import TagFilterPanel from './TagFilterPanel.js'
import {
  closeModal,
  modalFormSelector,
  applyFilter,
  errorsSelector,
  updateModalForm,
  STATUS_FILTER_PANEL,
  ALLOCATION_FILTER_PANEL,
  SALES_CHANNEL_FILTER_PANEL,
  SUPPLIER_FILTER_PANEL,
  WAREHOUSE_FILTER_PANEL,
  DATE_RANGE_FILTER_PANEL,
  MISC_FILTER_PANEL,
  TAG_FILTER,
  clearFilters,
  SHIPPER_FILTER_PANEL,
  showSaveFilterImpromptuModal,
  SKU_FILTER_PANEL,
  ORDER_NUMBER_FILTER_PANEL,
  ORDER_LIST_FILTER_OPTIONS,
} from './orderListFilterModalFunctions.js'
import StatusFilterPanel from './StatusFilterPanel.js'
import AllocationFilterPanel from './AllocationFilterPanel.js'
import SalesChannelFilterPanel from './SalesChannelFilterPanel.js'
import SupplierFilterPanel from './SupplierFilterPanel.js'
import WarehouseFilterPanel from './WarehouseFilterPanel.js'
import DateRangeFilterPanel from './DateRangeFilterPanel.js'
import MiscFilterPanel from './MiscFilterPanel.js'
import ShipperFilterPanel from './ShipperFilterPanel.js'
import Icon from '../../../../common/icons/Icon.js'
import {modalValidDateRangeFilterTypesOptionsSelector} from '../../orderListSelectors.js'
import TextInput from '../../../../common/components/TextInput.js'
import {NEW_FILTER_CONFIG_ID} from '../../../../data/filterConfigs.js'
import SKUFilterPanel from './SKUFilterPanel.js'
import OrderNumberFilterPanel from './OrderNumberFilterPanel.js'
import {
  filterOrderSelector,
  showFilterSettingsModal,
} from '../../../Modals/FilterSettingsModal.js'
import {PERMISSION_FILTER} from '../../../Settings/Users/Permissions.js'

const FILTER_PANEL_LIST = {
  [STATUS_FILTER_PANEL]: StatusFilterPanel,
  [ALLOCATION_FILTER_PANEL]: AllocationFilterPanel,
  [SHIPPER_FILTER_PANEL]: ShipperFilterPanel,
  [SALES_CHANNEL_FILTER_PANEL]: SalesChannelFilterPanel,
  [SUPPLIER_FILTER_PANEL]: SupplierFilterPanel,
  [WAREHOUSE_FILTER_PANEL]: WarehouseFilterPanel,
  [TAG_FILTER]: TagFilterPanel,
  [DATE_RANGE_FILTER_PANEL]: DateRangeFilterPanel,
  [ORDER_NUMBER_FILTER_PANEL]: OrderNumberFilterPanel,
  [SKU_FILTER_PANEL]: SKUFilterPanel,
  [MISC_FILTER_PANEL]: MiscFilterPanel,
}
const FILTER_ORDER_SETTINGS_KEY = 'order_list_filter_order'

function showOrderListFilterSettingsModal() {
  showFilterSettingsModal({
    title: 'Order List Filter Settings',
    userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
    listOptions: ORDER_LIST_FILTER_OPTIONS,
  })
}

function OrderListFilterModal({form}) {
  const filterList = useSelector((state) =>
    filterOrderSelector(state, {
      userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
      listOptions: ORDER_LIST_FILTER_OPTIONS,
    }),
  )
  const errors = useSelector(errorsSelector)

  return (
    <ConfirmModal
      title="Order Filters"
      modalSize="md"
      className="modal--order-list-filters"
      onConfirm={() => closeModal(applyFilter())}
      onCancel={() => closeModal()}
      confirmText={
        form.type === PERMISSION_FILTER
          ? 'Update'
          : !form.filterConfigID
            ? 'Apply'
            : form.filterConfigID === NEW_FILTER_CONFIG_ID
              ? 'Save Filter Set'
              : 'Update Filter Set'
      }
      cancelText="Cancel"
      preventHotKeyConfirm
      MiddleButtons={
        !form.filterConfigID && form.type !== PERMISSION_FILTER
          ? () => (
              <ButtonPrimary
                alt
                className="margin-right-10"
                isDisabled={errors.preventSave}
                onClick={() => showSaveFilterImpromptuModal()}
              >
                Save and Apply
              </ButtonPrimary>
            )
          : null
      }
      RightButtons={() => (
        <div className="flex--justify">
          <ButtonPrimary
            isOutlined
            className="btn--sm margin-right-10"
            onClick={() => clearFilters()}
          >
            Clear Filters
          </ButtonPrimary>
          <ButtonPrimary
            isOutlined
            className="btn--sm"
            onClick={() => showOrderListFilterSettingsModal()}
          >
            <Icon name="sym-settings" className="fs-01" />
          </ButtonPrimary>
        </div>
      )}
      isDisabled={errors.preventSave}
    >
      {form.filterConfigID && (
        <div className="wrap--modal-filters wrap--modal-filters-name">
          <div className="w-40 margin-bottom-20">
            <TextInput
              id="filter_config_name"
              label="Filter Set Name"
              value={form.filterConfigName}
              onChange={(filterConfigName) =>
                updateModalForm({filterConfigName})
              }
              errorMessage={errors.filterConfigName}
            />
          </div>
        </div>
      )}
      {filterList.map((item) => {
        const Panel = FILTER_PANEL_LIST[item]

        return Panel ? (
          <Panel
            key={item}
            modalFormSelector={modalFormSelector}
            errorsSelector={errorsSelector}
            updateModalForm={updateModalForm}
            modalValidDateRangeFilterTypesOptionsSelector={
              modalValidDateRangeFilterTypesOptionsSelector
            }
          />
        ) : null
      })}
    </ConfirmModal>
  )
}

export default onlyIfForm(OrderListFilterModal, modalFormSelector)
